

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import { toNumber } from '@/utils/moneyTreatments';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import DateUtils from '@/utils/DateUtils';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

interface ICustomer {
  id: string;
  label?: string;
  name: string;
  lastname: string;
  mail: string;
  createdAt: string;
  phone: string;
  birthday: string;
}

@Component({
  components: {
    FilledButton,
    FormLabel,
    Description,
    Subtitle,
    Container,
    Checkbox,
    SelectorAndList,
    TextField,
    Typography
  }
})
export default class TwismWalletSendCoins extends Vue {
  @Prop() readonly data!: any;
  coins = '';

  loading = false;
  adminService = new AdminService();

  customers: ICustomer[] = this.mapCustomers(
    (this.data.groups &&
      this.data.groups[0] &&
      this.data.groups[0].customers) ||
      []
  );
  customersOptions: ICustomer[] = [];

  async searchCustomers(search: string) {
    try {
      const { data } = await this.adminService.searchCustomers(search);
      const selectedIds = new Set(this.customers.map(c => c.id));
      this.customersOptions = this.mapCustomers(
        data.items
          .map(({ customer }: any) => customer)
          .filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.customersOptions = [];
      this.$notification(treatError(e));
    }
  }

  isValid() {
    if (!this.customers.length || !this.coins || toNumber(this.coins) <= 0) {
      this.$notification('Please fill the fields', 'error');

      return false;
    }

    if (toNumber(this.coins) > toNumber(this.data.coins)) {
      this.$notification(
        'This wallet has insufficient funds at the moment',
        'error'
      );

      return false;
    }

    return true;
  }

  get descriptionCustomer() {
    return `
        Name: ${this.customers[0].name} ${this.customers[0].lastname}
        <br />
        E-mail: ${this.customers[0].mail}
        <br />
        Phone: ${this.customers[0].phone || ''}
        <br />
        Birthday: ${
          this.customers[0].birthday
            ? this.getDate(this.customers[0].birthday)
            : ''
        }
        <br />
        Member since: ${this.getDate(this.customers[0].createdAt)}
        `;
  }

  async sendCoins() {
    if (!this.isValid()) {
      return;
    }

    const onConfirm = async () => {
      try {
        const { status } = await this.adminService.sendTwismCoins(
          this.data.id,
          this.customers[0].id,
          toNumber(this.coins)
        );
        if (status === 201) {
          this.$notification('Success');
          eventBus.$emit('closeModal');
          eventBus.$emit('reloadTwismWallet', false);
          eventBus.$emit('reloadTwismWalletHistory');
          this.closeModal();
        }
      } catch (e) {
        console.error(e);
        treatError(e);
      } finally {
        this.loading = false;
      }
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'twismWalletConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          coins: toNumber(this.coins),
          customer: this.customers[0]
        },
        title: `Are you sure?`,
        subtitle: `${toNumber(this.coins)} Coins will be sent to:`,
        description: this.descriptionCustomer,
        onConfirm
      }
    );
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date: date,
      applyTimezone: true
    });
  }

  mapCustomers(customers: ICustomer[] = []) {
    return customers.map(customer => {
      return {
        label: `${customer.name} ${customer.lastname} (${customer.mail})`,
        ...customer
      };
    });
  }

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }
}
